<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="edit-profile">
    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-header">
            <div class="media">
              <img class="img-70 rounded-circle" alt="" src="{{urlImage}}">
              <div class="media-body align-self-center">
                <h3 >&nbsp;{{profileForm.get('firstName')?.value}} {{profileForm.get('lastName')?.value}}</h3>
              </div>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="passwordForm" class="ngx-form" novalidate>
            <div class="form-group">
              <label class="control-label" for="f1-password">Current password</label>
              <input type="password" formControlName="passwordCurrent" class="form-control" autocomplete="off"
                  placeholder="enter current password..">
              <div *ngIf="passwordForm.controls['passwordCurrent'].invalid && (passwordForm.controls['passwordCurrent'].dirty || passwordForm.controls['passwordCurrent'].touched)"
                    class="alert">
                <div *ngIf="passwordForm.controls['passwordCurrent'].errors?.['required']">
                      Password is required.
                </div>
                <div *ngIf="passwordForm.controls['passwordCurrent'].errors?.['minlength']">Password must be at least 8 characters</div>
              </div>
            </div>

              <div class="form-group">
                <label class="control-label" for="f1-password">New password</label>
                <input type="password" formControlName="passwordNew" class="form-control" autocomplete="off"
                  placeholder="enter new password..">
                <div
                  *ngIf="passwordForm.controls['passwordNew'].invalid && (passwordForm.controls['passwordNew'].dirty || passwordForm.controls['passwordNew'].touched)"
                  class="alert">
                  <div *ngIf="passwordForm.controls['passwordNew'].errors?.['required']">
                    Password is required.</div>
                  <div *ngIf="passwordForm.controls['passwordNew'].errors?.['minlength']">Password must be at least 8 characters</div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label" for="f1-repeat-password">Repeat password</label>
                <input type="password" formControlName="confirmPassword" class="form-control" autocomplete="off"
                  placeholder="repeat password ..">
                <div
                  *ngIf="passwordForm.controls['confirmPassword'].invalid && (passwordForm.controls['confirmPassword'].dirty || passwordForm.controls['confirmPassword'].touched)"
                  class="alert">
                  <div *ngIf="passwordForm.controls['confirmPassword'].errors?.['required']">
                    Password is required.</div>
                  <div *ngIf="passwordForm.controls['confirmPassword'].errors?.['mustMatch']">
                    Password does not match
                  </div>
                </div>
              </div>

              <div class="form-footer">
                <button class="btn btn-sm btn-pill btn-primary btn-submit" type="submit" ngbTooltip="save new password" [disabled]="!passwordForm.valid"
                (click)="onSave()">Change password</button>
              </div>

            </form>
          </div>
        </div>
      </div>

      <div class="col-lg-8">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">Details</h5>
          </div>
          <div class="card-body">
            <form [formGroup]="profileForm" class="ngx-form" novalidate>
              <div class="row">

                <div class="col-lg-2 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="username">Username</label>
                    <input type="text" formControlName="userName" class="form-control" placeholder="enter user name.." >
                    <div *ngIf="profileForm.controls['userName'].invalid && (profileForm.controls['userName'].dirty || profileForm.controls['userName'].touched)"
                        class="alert">
                        <div *ngIf="profileForm.controls['userName'].errors?.['required']">
                            User name is required.
                        </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="firstname">First Name</label>
                    <input type="text" formControlName="firstName" class="form-control" placeholder="enter first name..">
                    <div *ngIf="profileForm.controls['firstName'].invalid && (profileForm.controls['firstName'].dirty || profileForm.controls['firstName'].touched)"
                        class="alert">
                        <div *ngIf="profileForm.controls['firstName'].errors?.['required']">
                            First Name is required.
                        </div>
                        <div *ngIf="profileForm.controls['firstName'].errors?.['pattern']">
                            Number is not allowed!
                        </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="lastname">Last Name</label>
                    <input type="text" formControlName="lastName" class="form-control" placeholder="enter last name..">
                    <div *ngIf="profileForm.controls['lastName'].invalid && (profileForm.controls['lastName'].dirty || profileForm.controls['lastName'].touched)"
                        class="alert">
                        <div *ngIf="profileForm.controls['lastName'].errors?.['required']">
                            Last Name is required.
                        </div>
                        <div *ngIf="profileForm.controls['lastName'].errors?.['pattern']">
                            Number is not allowed!
                        </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="email">Email</label>
                    <input type="email" formControlName="email" class="form-control" autocomplete="off"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" [email]="true" required="required" placeholder="enter email..">
                    <div
                      *ngIf="profileForm.controls['email'].invalid && (profileForm.controls['email'].dirty || profileForm.controls['email'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['email'].errors?.['pattern']">
                        Email is required and format should be <i>john@doe.com</i>
                      </div>
                      <div *ngIf="profileForm.controls['email'].errors?.['required'] ">Email is required.</div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="company">Company</label>
                    <input type="text" formControlName="company" class="form-control" placeholder="enter company.." >
                  </div>
                </div>

                <div class="col-lg-6 col-md-4 col-12">
                  <div class="form-group">
                    <label class="control-label" for="company">TAX/VAT ID</label>
                    <input type="text" formControlName="tax" class="form-control" placeholder="enter TAX..">
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-12">
                  <div class="form-group">
                    <label>Address</label>
                    <input type="text" formControlName="street" class="form-control" placeholder="enter street & number..">
                    <div *ngIf="profileForm.controls['street'].invalid && (profileForm.controls['street'].dirty || profileForm.controls['street'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['street'].errors?.['required']">
                        Street name and number is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-2 col-md-2 col-4">
                  <div class="form-group">
                    <label>Zip/Postal code</label>
                    <input type="text" formControlName="zip" class="form-control" placeholder="Zip/Postal..">
                    <div *ngIf="profileForm.controls['zip'].invalid && (profileForm.controls['zip'].dirty || profileForm.controls['zip'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['zip'].errors?.['required']">
                        Zip/Postal code number is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4 col-md-4 col-8">
                  <div class="form-group">
                    <label>City</label>
                    <input type="text" formControlName="cityName" class="form-control" placeholder="enter city..">
                    <div *ngIf="profileForm.controls['cityName'].invalid && (profileForm.controls['cityName'].dirty || profileForm.controls['cityName'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['cityName'].errors?.['required']">
                        City name is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 col-md-6 col-12">
                  <div class="form-group">
                    <i class="flag-icon flag-icon-{{flag | lowercase}}"></i>&nbsp;
                    <label>Country</label>
                    <select id="country" class="form-select" formControlName="country" (change)="setFlag($event)">
                      <option [ngValue]="null" selected disabled>country..</option>
                      <option *ngFor="let country of countryData" value="{{country.id}}">{{country.name}}</option>
                    </select>
                    <div *ngIf="profileForm.controls['country'].invalid && (profileForm.controls['country'].dirty || profileForm.controls['country'].touched)"
                      class="alert">
                      <div *ngIf="profileForm.controls['country'].errors?.['required']">
                        Country name is required.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group mb-0">
                    <label class="control-label" for="note">About me</label>
                    <textarea rows="3" formControlName="note" class="form-control" placeholder="enter info if you like.."></textarea>
                  </div>
                </div>

                <div class="card-footer">
                  <button class="btn btn-sm btn-pill btn-primary btn-submit" type="submit" ngbTooltip="update profile data" [disabled]="!profileForm.valid"
                  (click)="onUpdate()">Update</button>
                </div>
              </div>
            </form>

          </div>
        </div>
        </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
